export default class FlipSwitch extends React.Component {
    constructor(props) {
        super(props);

        this.circleSize = 25;

        this.onText = props.onText || gettext('on').toUpperCase();
        this.offText = props.offText || gettext('off').toUpperCase();

        this.state = Object.assign(
            {
                textWidth: null,
                loading: false
            },
            this.getStateForProps(props)
        );
    }

    getStateForProps(props) {
        return {
            on: Boolean(props.on)
        };
    }

    componentDidMount() {
        const onTextWidth = this.onTextEl.offsetWidth || 10;
        const offTextWidth = this.offTextEl.offsetWidth || 10;

        if (onTextWidth > offTextWidth) {
            this.setState({ textWidth: onTextWidth });
        } else {
            this.setState({ textWidth: offTextWidth });
        }
    }

    render() {
        return (
            <div style={this.getButtonContainerStyle()}>
                <div
                    style={this.getButtonStyle()}
                    onClick={() => this.flip()}
                >
                    <div style={this.getSliderContentStyle()}>

                        <span
                            ref={el => {this.onTextEl = el;}}
                            style={this.getTextStyle()}
                        >
                            {this.onText}
                        </span>

                        <span style={this.getCircleStyle()}>
                            <span style={this.getInnerCircleStyle()} />
                            {this.getLoadingIcon()}
                        </span>

                        <span
                            ref={el => {this.offTextEl = el;}}
                            style={this.getTextStyle()}
                        >
                            {this.offText}
                        </span>

                    </div>
                </div>
            </div>
        );
    }

    getButtonContainerStyle() {
        return {
            display: 'inline-block',
            width: this.getButtonWidth() + 6,
            height: 35,
            borderRadius: this.circleSize,
            background: 'linear-gradient(#DDD, #DADADA)',
            padding: 3
        };
    }

    getButtonStyle() {
        return {
            position: 'relative',
            overflow: 'hidden',
            width: this.getButtonWidth(),
            height: 29,
            background: this.getButtonBackgroundColor(),
            transition: 'background 250ms',
            color: 'white',
            borderRadius: this.circleSize,
            boxShadow: 'rgb(97, 97, 97) 0px 2px 5px 0px inset',
            cursor: 'pointer',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            KhtmlUserSelect: 'none',
            WebkitUserSelect: 'none',
            WebkitTouchCallout: 'none'
        };
    }

    getButtonWidth() {
        if (this.state.textWidth) {
            return this.state.textWidth + (2 * this.circleSize);
        } else {
            return 'auto';
        }
    }

    getButtonBackgroundColor() {
        if (this.state.on) {
            return 'green';
        } else {
            return '#C00000';
        }
    }

    getSliderContentStyle() {
        return Object.assign(
            {
                display: 'inline-flex',
                position: 'absolute',
                marginTop: 2,
                whiteSpace: 'nowrap',
                marginLeft: 13,
                marginRight: 13
            },
            this.getSliderContentPositionStyle()
        );
    }

    getSliderContentPositionStyle() {
        // If `this.state.textWidth` is not yet set, return a style without
        // transition, otherwise you could see a transition when the page
        // loads, which is a bit weird and distracting.
        if (this.state.textWidth) {
            return {
                left: this.getSliderContentLeftStyle(),
                transition: 'left 250ms'
            };
        } else {
            if (this.state.on) {
                return { left: 0 };
            } else {
                return { right: 0 };
            }
        }
    }

    getSliderContentLeftStyle() {
        if (this.state.on) {
            return 0;
        } else {
            return -(this.state.textWidth + 20);
        }
    }

    getTextStyle() {
        return {
            width: this.getTextWidthStyle(),
            textAlign: 'center',
            fontWeight: 600
        };
    }

    getTextWidthStyle() {
        if (this.state.textWidth) {
            return this.state.textWidth;
        } else {
            return 'auto';
        }
    }

    getCircleStyle() {
        return {
            position: 'relative',
            display: 'inline-block',
            margin: '0 10px',
            width: this.circleSize,
            height: this.circleSize,
            borderRadius: this.circleSize,
            background: 'white',
            color: 'black'
        };
    }

    getInnerCircleStyle() {
        return {
            position: 'absolute',
            display: 'inline-block',
            top: 5,
            left: 5,
            width: this.circleSize - 10,
            height: this.circleSize - 10,
            borderRadius: this.circleSize,
            background: 'linear-gradient(#e0dfdf, #f9f9f9)',
            color: 'black'
        };
    }

    getLoadingIcon() {
        if (this.state.loading) {
            return (
                <span
                    className='fa fa-circle-notch fa-spin'
                    style={{
                        position: 'absolute',
                        top: 3,
                        left: 3,
                        fontSize: 19,
                        color: 'grey'
                    }}
                />
            );
        }
    }

    flip() {
        if (this.props.onChange) {
            const onChangeResponse = this.props.onChange();

            if (onChangeResponse) {
                if (isPromise(onChangeResponse)) {
                    this.setState({ loading: true });
                    onChangeResponse.then(() => this.toggleOn());
                } else {
                    this.toggleOn();
                }
            }
        } else {
            this.toggleOn();
        }
    }

    toggleOn() {
        this.setState({
            loading: false,
            on: !this.state.on
        });
    }
}


function isPromise(obj) {
    return Promise.resolve(obj) == obj;
}
